<template>
    <div class="three-bounce">
        <div class="loading_point one" :style="pointStyle"></div>
        <div class="loading_point two" :style="pointStyle"></div>
        <div class="loading_point three" :style="pointStyle"></div>
    </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    props:{
        size: {
            type: Number,
            default: 18,
        },
        color: {
            type: String,
            default: "#aeadba"
        }
    },
    computed:{
        pointStyle(){
            return{
                width: this.size + "px",
                height: this.size + "px",
                background: this.color
            }
        }
    }
}
</script>

<style type="text/css" scoped>
    .three-bounce {
        text-align: center;
        width: 100%;
    }

    .three-bounce>.loading_point {
        animation: bouncedelay 1.4s ease-in-out infinite;
        animation-fill-mode: both;
        border-radius: 100%;
        display: inline-block;
        background-color: #aeadba;
        height: 18px;
        top: 50%;
        width: 18px;
    }

    .three-bounce .one {
        animation-delay: -.32s;
    }

    .three-bounce .two {
        animation-delay: -.16s;
    }

    @-webkit-keyframes bouncedelay {
        0%,80%,100% {
            transform: scale(0);
        }

        40% {
            transform: scale(1);
        }
    }

    @keyframes bouncedelay {
        0%,80%,100% {
            transform: scale(0);
        }

        40% {
            transform: scale(1);
        }
    }
</style>